"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileExtension = exports.getStarMessageRequestData = exports.getLinkOnText = exports.attachmentType = exports.docType = exports.mediaMessageBody = exports.fileType = void 0;
exports.bytesToSize = bytesToSize;
const models_1 = require("../models");
const regex_1 = require("../regex");
const fileType = (file) => {
    if (file.type.includes("image/"))
        return models_1.FILE_TYPE.IMAGE;
    else if (file.type.includes("video/"))
        return models_1.FILE_TYPE.VIDEO;
    else if (file.type.includes("audio/"))
        return models_1.FILE_TYPE.AUDIO;
    else
        return models_1.FILE_TYPE.DOC;
};
exports.fileType = fileType;
const mediaMessageBody = (mediaDraft, type) => {
    switch (type) {
        case models_1.FILE_TYPE.IMAGE:
            return {
                body: models_1.SOCKET_BODY_EMOJI.IMAGE,
                contentType: models_1.MESSAGE_CONTENT_TYPE.IMAGE,
                images: [baseObj(mediaDraft)],
            };
        case models_1.FILE_TYPE.AUDIO:
            return {
                body: models_1.SOCKET_BODY_EMOJI.AUDIO,
                contentType: models_1.MESSAGE_CONTENT_TYPE.VOICE,
                voiceMessage: voiceObj(mediaDraft),
            };
        case models_1.FILE_TYPE.VIDEO:
            if (!mediaDraft.uploadedThumbnailUrl) {
                throw new Error("Thumbnail not generated");
            }
            return {
                body: models_1.SOCKET_BODY_EMOJI.VIDEO,
                contentType: models_1.MESSAGE_CONTENT_TYPE.VIDEO,
                videos: [videoObj(mediaDraft)],
            };
        default:
            return {
                body: models_1.SOCKET_BODY_EMOJI.DOCUMENT,
                contentType: models_1.MESSAGE_CONTENT_TYPE.DOCUMENT,
                documents: [documentObj(mediaDraft)],
            };
    }
};
exports.mediaMessageBody = mediaMessageBody;
const baseObj = (mediaDraft) => {
    const { text } = mediaDraft;
    const docObj = {};
    if (text && text.length > 0) {
        docObj["text"] = text;
    }
    docObj["url"] = mediaDraft.uploadedUrl;
    return docObj;
};
const voiceObj = (mediaDraft) => {
    const voiceObject = baseObj(mediaDraft);
    if ("duration" in mediaDraft.mediaFile) {
        voiceObject["duration"] = mediaDraft.mediaFile.duration;
    }
    voiceObject["mediaType"] = mediaDraft.mediaFile.ext();
    return voiceObject;
};
const videoObj = (mediaDraft) => {
    const videoObject = baseObj(mediaDraft);
    if ("duration" in mediaDraft.mediaFile) {
        videoObject["duration"] = mediaDraft.mediaFile.duration;
    }
    videoObject["thumbnail"] = mediaDraft.uploadedThumbnailUrl;
    return videoObject;
};
const documentObj = (mediaDraft) => {
    const documentObject = baseObj(mediaDraft);
    documentObject["size"] = bytesToSize(mediaDraft.mediaFile.size);
    documentObject["docType"] = (0, exports.docType)(mediaDraft.mediaFile.name);
    return documentObject;
};
const docType = (fileUrl) => {
    const fileExt = (0, exports.getFileExtension)(fileUrl);
    switch (fileExt.toUpperCase()) {
        case "PDF":
            return models_1.MESSAGE_CONTENT_DOCUMENT_TYPE.PDF;
        case "XLS":
        case "XLSX":
            return models_1.MESSAGE_CONTENT_DOCUMENT_TYPE.XLS;
        case "DOC":
        case "DOCX":
            return models_1.MESSAGE_CONTENT_DOCUMENT_TYPE.DOC;
    }
};
exports.docType = docType;
const attachmentType = (fileUrl) => {
    const fileExt = (0, exports.getFileExtension)(fileUrl);
    switch (fileExt.toUpperCase()) {
        case "PDF":
            return models_1.ATTACHMENT_TYPE.PDF;
        case "XLS":
        case "XLSX":
            return models_1.ATTACHMENT_TYPE.XLS;
        case "DOC":
        case "DOCX":
            return models_1.ATTACHMENT_TYPE.DOC;
    }
};
exports.attachmentType = attachmentType;
function bytesToSize(bytes, decimals = 2) {
    try {
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    }
    catch (error) {
        return "1 Byte";
    }
}
const getLinkOnText = (text) => {
    try {
        const linkArray = [];
        text.replace(regex_1.Regex.DETECT_LINKS_AND_EMAILS, (fullMatch, boundary, detectedLink) => {
            let newURL = detectedLink;
            const isEmail = regex_1.Regex.email.test(newURL);
            if (isEmail) {
                newURL = `mailto:${newURL}`;
            }
            else {
                if (!newURL.toLowerCase().startsWith("http") &&
                    !newURL.startsWith("mailto:")) {
                    newURL = `http://${newURL}`;
                }
            }
            linkArray.push(newURL);
            return "";
        });
        return linkArray;
    }
    catch (error) {
        return [];
    }
};
exports.getLinkOnText = getLinkOnText;
const getStarMessageRequestData = (action, messageData) => ({
    action,
    chatId: messageData.chatId,
    chatType: messageData.chatType,
    messageId: messageData.id,
});
exports.getStarMessageRequestData = getStarMessageRequestData;
const getFileExtension = (uri) => {
    const re = /(?:\.([^.]+))?$/;
    const fileNameArray = re.exec(uri);
    return fileNameArray && fileNameArray.length > 1 ? fileNameArray[1] : "";
};
exports.getFileExtension = getFileExtension;
